<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between">
    <h5 class="mb-0">
        <ng-container *ngFor="let breadcrumb of folder_bradcrumb_details; index as i">
            <button mat-button class="more-bread" 
                *ngIf="folder_bradcrumb_details?.length > 3 && i === 0"
                [matMenuTriggerFor]="bread_menu">
                <i class="ri-more-fill fs-24"></i>
            </button>
            <ng-container *ngIf="folder_bradcrumb_details?.length > 3; else small_bread">
                <i class="ri-arrow-right-s-line  va-middle fs-24 fw-medium muted-color" 
                    *ngIf="i > bread_limit"></i>
                <span 
                    *ngIf="(i+1) > bread_limit"
                    [ngClass]="{'highlight-bread': breadcrumb?.url &&  i < (folder_bradcrumb_details?.length - 1)}" 
                    (click)="breadcrumbNavigation(breadcrumb)">
                    {{breadcrumb?.name}} 
                </span>
            </ng-container>
            <ng-template #small_bread>
                <i class="ri-arrow-right-s-line  va-middle fs-24 fw-medium muted-color" *ngIf="i > 0"></i>
                <span 
                    [ngClass]="{'highlight-bread': breadcrumb?.url &&  i < (folder_bradcrumb_details?.length - 1)}" 
                    (click)="breadcrumbNavigation(breadcrumb)">
                    {{breadcrumb?.name}}
                </span>
            </ng-template>
        </ng-container>
        <mat-menu #bread_menu="matMenu" class="dotMenu monthMenu" xPosition="after">
            <ng-container *ngFor="let breadcrumb of folder_bradcrumb_details; index as i">
                <button mat-menu-item type="button" 
                    class="bg-transparent border-none position-relative" 
                    (click)="breadcrumbNavigation(breadcrumb)"
                    *ngIf="i < bread_limit">
                    <i class="flaticon flaticon-folder"></i>
                    <h6 class="p-10">{{breadcrumb?.name}} </h6>
                </button>
            </ng-container>
        </mat-menu>
    </h5>
    
    <div class="d-flex">
        <form class="tagus-search-box" [formGroup]="search_form">
            <input type="text" 
                class="input-search border-radius" 
                placeholder="Search here" 
                formControlName="search">
        </form>
        <button mat-flat-button 
            class="tagus ms-10" 
            *ngIf="drive_type === type.home"
            [matMenuTriggerFor]="new_menu">
            <i class="ri-add-fill"></i> New
        </button>
        <mat-menu #new_menu="matMenu" class="dotMenu monthMenu" xPosition="before">
            <button mat-menu-item type="button" 
                class="bg-transparent border-none position-relative" 
                (click)="createFolder()">
                <i class="ri-add-fill"></i> Create Folder
            </button>
            <button mat-menu-item type="button" 
                class="bg-transparent border-none position-relative"
                (click)="createFile()">
                <i class="ri-add-fill"></i> Upload File
            </button>
        </mat-menu>
        
        <mat-button-toggle-group #group="matButtonToggleGroup" class="ms-10" (change)="layoutChanged($event)" [value]="layout_type.list">
            <mat-button-toggle [value]="layout_type.list" aria-label="Text align left" sele>
                <mat-icon>format_align_left</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle [value]="layout_type.grid" aria-label="Text align center">
                <mat-icon>grid_on</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>